import React from 'react';
import { HOME_URL } from 'config';

const LogoutPage = () => {
  document.body.style.backgroundColor = 'white';

  return (
    <div className="loading">
      <div className="account-pages mt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="circle">
                <div className="circle_text">
                  <div className="circle_text">✓</div>
                </div>
              </div>
              <div className="text-center">
                <h2 className="mt-3">您已成功登出</h2>
                <a
                  href={HOME_URL || ''}
                  className="btn btn-primary waves-effect waves-light"
                >
                  返回登入頁
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="footer-alt">
        <script>document.write(new Date().getFullYear())</script> &copy;
        TRADE-VAN.COM ALL RIGHTS RESERVED.
      </footer>
    </div>
  );
};

export default LogoutPage;
